import request from '@/utils/request';
import { TableListQueryParams, UserInfoType, orderType, getTableList, productExplainType,noticeInfoType, selfOrPostSearchType } from './data.d';
import qs from 'qs'

export async function dailynewArticles(): Promise<any> {
  return request({
      url: '/home/articles/dailynew',
      method: 'get'
  });
}

export async function weeknewWorks(): Promise<any> {
  return request({
      url: '/home/works/weeknew',
      method: 'get'
  });
}

export async function monthnewTopics(): Promise<any> {
  return request({
      url: '/home/topics/monthnew',
      method: 'get'
  });
}

export async function annualnewLinks(): Promise<any> {
  return request({
      url: '/home/links/annualnew',
      method: 'get'
  });
}

export async function hotSearchQueryList(params?: TableListQueryParams): Promise<any> {
  return request({
    url: '/home/searchs/keywords',
    method: 'get',
    params,
  });
}

export async function hotTagsQueryList(params?: TableListQueryParams): Promise<any> {
  return request({
    url: '/home/tags',
    method: 'get',
    params,
  });
}

export async function articleHitQueryList(params?: TableListQueryParams): Promise<any> {
  return request({
    url: '/home/articles',
    method: 'get',
    params,
  });
}

export async function worksHitQueryList(params?: TableListQueryParams): Promise<any> {
  return request({
    url: '/home/works',
    method: 'get',
    params,
  });
}

//首页单量接口
export async function getOrderNumber(params:UserInfoType) {
  return request({
      url: '/seller/v1/homePage/getOrderNumber',
      method: 'POST',
      data: params
  })
}

// 首页时效展示接口
export async function getTimeliness(params:orderType) {
  return request({
      url: '/seller/v1/homePage/timelinessView',
      method: 'POST',
      data: params
  })
}


export async function getPageList(params:getTableList) {
  return request({
      url: '/seller/v1/specialProduct/getPageList',
      method: 'POST',
      data: params
  })
}

export async function productExplainList(params:productExplainType) {
  return request({
      url: '/seller/v1/productExplain/getList',
      method: 'POST',
      data: params
  })
}

export async function pickupScopeInfo() {
  return request({
      url: '/seller/v1/homePage/pickupScope',
      method: 'POST',
  })
}

export async function selfDeliveryScopeInfo(params:selfOrPostSearchType) {
  return request({
      url: '/seller/v1/homePage/selfDeliveryScope',
      method: 'POST',
      data: params
  })
}

export async function noticeInfo(params:noticeInfoType) {
  return request({
      url: '/seller/v1/homePage/notice',
      method: 'POST',
      data: qs.stringify(params)
  })
}


